import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();
  const rows = [1, 2, 3, 4, 5];

  return (
    <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">{t('compare.title')}</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600">{t('compare.subtitle')}</p>
      </div>

      <div className="mt-10 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-background-200 bg-background-100">
                <th className="px-5 py-4 font-semibold text-foreground-900">{t('compare.col.resource')}</th>
                <th className="px-5 py-4 font-semibold text-foreground-900">{t('compare.col.category')}</th>
                <th className="px-5 py-4 font-semibold text-foreground-900">{t('compare.col.info')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((n) => (
                <tr key={n} className="border-b border-background-200 last:border-b-0">
                  <td className="px-5 py-4 font-medium text-foreground-950">{t(`compare.row${n}.resource`)}</td>
                  <td className="px-5 py-4">
                    <span className="inline-flex items-center rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                      {t(`compare.row${n}.category`)}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-foreground-600">{t(`compare.row${n}.info`)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}